export default __webpack_public_path__ + "static/media/usmog.cc55a01d.png";